import {
  FilterSection,
  MainContent, NothingToShow,
  SearchContainer,
  SortDropdown, UpdateDate, UpdateDescription, UpdateItem, UpdateList, UpdateName,
  UpdatesHeader
} from "~/views/Search/Response/Case/components/CaseProgress/CaseProgress.style";
import {Paginate, SimpleInput, SimpleLoading, SimpleSelect} from "~/components";
import {Calendar, ChevronDown, Search} from "react-feather";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useFetch} from "~/hooks";

const CaseProgress = ({caseNumber, isPrinting, infoLoading, hasContent}) => {
  const [pagesCount, setPagesCount] = useState(0);
  const [perPage, setPerPage] = useState(50);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState({ value: 20, label: 20 });
  const [searchField, setSearchField] = useState('');
  const [orderDirection, setOrderDirection] = useState({
    label: "Mais recente",
    value: "desc",
  });

  const { t } = useTranslation('diligence');
  const { t: tResults } = useTranslation('results');
  const [paginate, setPaginate] = useState(1)

  const { data: caseProgress, loading, isValidating } = useFetch({
    url: `/case-progress?case_number=${caseNumber}&paginate=${paginate}&page=${page}&per_page=${size.value}&search=${searchField}&order_direction=${orderDirection.value}`
  });

  useEffect(() => {

    setPagesCount(0);
    setPerPage(50);
    setTotal(0);
    setPage(1);
    setSize({ value: 20, label: 20 });
    setSearchField('');
    setOrderDirection({
      label: "Mais recente",
      value: "desc",
    });

    if(isPrinting){
      setPaginate(0)
    }else{
      setPaginate(1)
    }
    
  }, [isPrinting])

  useEffect(() => {
    infoLoading(isValidating)
  }, [isValidating, infoLoading])

  useEffect(() => {
    if (caseProgress) {
      setPage(caseProgress.current_page);
      setPerPage(caseProgress.per_page);
      setTotal(caseProgress.total);
      setPagesCount(caseProgress.last_page);
      hasContent(true)
    }else{
      hasContent(false)
    }
  }, [caseProgress]);

  const caseProgressEntries = useMemo(() => {
    if (!caseProgress) {
      return [];
    }

    return (caseProgress.data || caseProgress).map(item => {
      const [datePart, timePart] = item.date.split(' ');
      const [year, month, day] = datePart.split('-');
      
      return {
        ...item,
        date: `${day}/${month}/${year}, ${timePart}`
      };
    });
  }, [caseProgress]);

  const orderByOption = useMemo(() => {
    return [
      {
        label: t("case_progress.order_direction.newest"),
        value: "desc",
      },
      {
        label: t("case_progress.order_direction.oldest"),
        value: "asc",
      }
    ];
  }, []);
  
  return (
    <>
      <FilterSection className="no-print">
        <SearchContainer>
          <SimpleInput
            isSearch
            name="search"
            icon={<Search/>}
            value={searchField}
            onValue={setSearchField}
            onChange={({target}) => setSearchField(target.value)}
            placeholder={tResults('components.search')}
            appearance="secondary"
          />
        </SearchContainer>
        <SortDropdown>
          <SimpleSelect
            isReveal={true}
            icon={ChevronDown}
            value={orderDirection}
            options={orderByOption}
            onChange={(order) => setOrderDirection(order)}
            appearance="secondary"
            placeholder={t("case_progress.order_direction.newest")}
          />
        </SortDropdown>
      </FilterSection>

      <MainContent>
        { !caseProgress && isValidating ? <SimpleLoading /> : (caseProgressEntries?.length > 0 
          ? <>
            <UpdatesHeader>{total} movimentações</UpdatesHeader>
            <UpdateList>
              {caseProgressEntries?.map((caseProgressEntry, index) => (
                <UpdateItem key={index}>
                  <UpdateDate>
                    <span><Calendar size={16}/></span> {caseProgressEntry.date}
                  </UpdateDate>
                  <UpdateName>
                    {caseProgressEntry.name}
                  </UpdateName>

                  {caseProgressEntry.description && (
                    <UpdateDescription>
                      {caseProgressEntry.description}
                    </UpdateDescription>
                  )}

                </UpdateItem>
              ))}
            </UpdateList>
          </>
          : <NothingToShow>{t("case_progress.empty")}</NothingToShow>
        )
        }
      </MainContent>

      <Paginate
        size={size}
        onSize={setSize}
        onPaginate={setPage}
        currentPage={page}
        pages={pagesCount}
        total={total}
        perPage={perPage}
        className="m-auto m-t-48"
      />
    </>
  )
}

export default CaseProgress;

CaseProgress.defaultProps = {
  isPrinting: false
}
